import React, { useContext, useState, useEffect } from 'react'
import Slider from '../components/Slider'
import ProductGrid from '../components/ProductGrid'
import CatagoryGrid from '../components/CatagoryGrid'
import { ProductContext } from '../context/ProductContext'

const Home = () => {

  const [recommendedProduct, setRecommendedProduct] = useState([]);

  const { products, mostBuyProducts, fetchProducts, fetchPBuyProducts } = useContext(ProductContext)
  const getTopBestSellers = (data, topN = 4) => data.slice(0, topN);

  const topBestSellers = getTopBestSellers(mostBuyProducts);

  useEffect(() => {
    fetchProducts();
    fetchPBuyProducts();
  }, []);


  useEffect(() => {
    setRecommendedProduct(products)
  })


  return (
    <>

      {/* Home Slider */}
      <Slider />
      {/* Home Slider */}

      {
        recommendedProduct.length > 0 ? (
          <ProductGrid section="Recomended for you" products={recommendedProduct} />
        ) : (
          <div className="d-flex justify-content-center align-items-center vh-100">
            <p className="text-center text-muted fs-5">No product found</p>
          </div>
        )
      }

      <ProductGrid section="Best sellers" products={topBestSellers} />
      <CatagoryGrid section="Categories" qty="6" />

    </>
  )

}

export default Home